export default __webpack_public_path__ + "static/media/loader.a04064ef.gif";